import React from 'react';
import { AnalyticsLocationProvider } from 'latitude-analytics';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import Accordion from './Accordion/Accordion';
import Button from '@latitude/button-rebrand';
import { INLINES, BLOCKS } from '@contentful/rich-text-types';
import Typography from '@latitude/typography';
import { REBRAND_COLOR } from '@latitude/core/utils/constants';
import { PADDING } from '@/utils/constants';
import parse from 'html-react-parser';
import { StyledSection } from './FaqRebrand.styled';

const FaqRebrand = ({
  title = 'Frequently Asked Questions',
  accordions = [],
  ctaText,
  ctaUrl,
  contentfulID
}) => {
  const renderOptions = {
    renderNode: {
      [INLINES.EMBEDDED_ENTRY]: node => {
        if (node?.data?.target?.contentType?.sys?.id === 'simpleButton') {
          return (
            <Button
              theme="Link"
              href={node?.data?.target?.url}
              text={node?.data?.target?.text}
              trackEventData={{ location: 'frequently asked questions' }}
            />
          );
        }
      },
      [BLOCKS.PARAGRAPH]: (_, children) => (
        <Typography.Body color={REBRAND_COLOR.BLACK_70}>
          {children}
        </Typography.Body>
      )
    }
  };

  const renderContent = content => {
    if (!content) return null;

    // HTML string (your current case)
    if (typeof content === 'string') {
      return parse(content);
    }

    // Contentful rich text
    return documentToReactComponents(content, renderOptions);
  };

  const items = accordions.map(item => ({
    id: item.id || item.name,
    title: item.title,
    iconName: item?.icon,
    content: renderContent(item.content)
  }));

  return (
    <StyledSection
      id="faq"
      style={{
        backgroundColor: REBRAND_COLOR.WHITE,
        paddingTop: PADDING.P32,
        paddingBottom: PADDING.P32
      }}
    >
      <div
        data-contentful={contentfulID}
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '32px'
        }}
      >
        <Typography.H4>{title}</Typography.H4>

        <AnalyticsLocationProvider location="frequently asked questions">
          <Accordion items={items} className="faq-accordion"  hasSmoothScroll={false}/>
        </AnalyticsLocationProvider>

        {ctaUrl && (
          <Button
            className="faq-cta"
            variant="secondary-blue"
            size="lg"
            ctaText={ctaText}
            ctaUrl={ctaUrl}
            trackEventData={{
              label: ctaText,
              location: 'frequently asked questions'
            }}
            data-trackid="see-all-faq"
            style={{
              width: 'fit-content',
              margin: '0 auto'
            }}
          />
        )}
      </div>
    </StyledSection>
  );
};

export default FaqRebrand;